import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ModLocServiciiComponent } from './mod-loc-servicii.component';
import { AddModLocServiciiComponent } from './add-mod-loc-servicii/add-mod-loc-servicii.component';
import { EditModLocServiciiComponent } from './edit-mod-loc-servicii/edit-mod-loc-servicii.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from 'src/app/material.module';

@NgModule({
    declarations: [
        ModLocServiciiComponent,
        AddModLocServiciiComponent,
        EditModLocServiciiComponent
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        MaterialModule
    ]
    , exports: [ModLocServiciiComponent]
})
export class ModLocServiciiModule { }
